import {
  CatalogSettingsApiModel,
  CatalogSettingsModel,
  CatalogSettingsResponseModel,
} from './catalogSettings.model';

export const catalogSettingsAdapter = (
  settings: CatalogSettingsApiModel
): CatalogSettingsModel => ({
  h1: settings.h1,
  buttonAccentBackground: settings.button_accent_background,
  buttonAccentColor: settings.button_accent_color,
  filtersAccentColor: settings.filters_accent_color,
  secondaryColor: settings.secondary_color,
});

export const catalogSettingsResponseAdapter = ({
  data: { data },
}: CatalogSettingsResponseModel): CatalogSettingsModel =>
  catalogSettingsAdapter(data);
